module.exports = __webpack_public_path__ + "img/welcomes-preview-text-fanli-white.b09d0c8f.png";